import { render, staticRenderFns } from "./Bolsa.vue?vue&type=template&id=17f016d0&scoped=true"
import script from "./Bolsa.vue?vue&type=script&lang=js"
export * from "./Bolsa.vue?vue&type=script&lang=js"
import style0 from "./Bolsa.vue?vue&type=style&index=0&id=17f016d0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "17f016d0",
  null
  
)

export default component.exports